import { useFormContext, Controller } from 'react-hook-form';
import { AppInputBase, AppInputBaseProps } from './app-input-base';

//
//

export type AppInputProps = AppInputBaseProps & {
  name: string;
};

export const AppInput = ({ name, helperText, children, ...props }: AppInputProps) => {
  const { control } = useFormContext();

  //

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <AppInputBase
            error={!!fieldState.error}
            id={'input-' + field.name}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            inputRef={field.ref}
            helperText={fieldState.error?.message || helperText}
            FormHelperTextProps={{ style: { marginLeft: 0 } }}
            {...props}
          >
            {children}
          </AppInputBase>
        );
      }}
    />
  );
};
